// Centered destructive modal. Cancel above Confirm — order matters to prevent
// fat-finger destruction.

import { useT } from "../lib/LocaleContext";

type Props = {
  open: boolean;
  babyName: string;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
};

export function DeleteConfirm({ open, babyName, onCancel, onConfirm }: Props) {
  const t = useT();
  if (!open) return null;
  return (
    <div style={styles.backdrop} onClick={onCancel}>
      <div style={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <div style={styles.iconWell}>
          <TrashIcon />
        </div>
        <h2 style={styles.title}>{t.deleteConfirm.title(babyName)}</h2>
        <p style={styles.body}>
          {t.deleteConfirm.body}
        </p>
        <button style={styles.cancel} onClick={onCancel}>
          {t.deleteConfirm.cancel}
        </button>
        <button style={styles.confirm} onClick={() => onConfirm()}>
          {t.deleteConfirm.confirm}
        </button>
      </div>
    </div>
  );
}

function TrashIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6" />
    </svg>
  );
}

const styles: Record<string, React.CSSProperties> = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "oklch(0 0 0 / 0.6)",
    zIndex: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  dialog: {
    width: "100%",
    maxWidth: 360,
    background: "var(--bh-surface)",
    borderRadius: 24,
    padding: "24px 22px",
    textAlign: "center",
  },
  iconWell: {
    width: 48,
    height: 48,
    borderRadius: 999,
    background: "var(--bh-attn-soft)",
    color: "var(--bh-attn)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,
  },
  title: { fontSize: 20, fontWeight: 600, margin: "0 0 10px", color: "var(--bh-ink)" },
  body: { fontSize: 15, lineHeight: 1.5, color: "var(--bh-ink-2)", margin: "0 0 18px" },
  cancel: {
    width: "100%",
    appearance: "none",
    background: "var(--bh-surface-2)",
    color: "var(--bh-ink)",
    border: "none",
    padding: "14px",
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 14,
    cursor: "pointer",
    minHeight: 56,
    marginBottom: 10,
  },
  confirm: {
    width: "100%",
    appearance: "none",
    background: "transparent",
    color: "var(--bh-attn)",
    border: "none",
    padding: "14px",
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
    minHeight: 56,
  },
};
